module.exports = __webpack_public_path__ + "static/Echinacea purpurea (Purple coneflower)-888d62229a1e24b5999d16da553db2a3.jpg";